export default function () {
    return {
        selectedCustomer: null,
        receiptLogsPerPage: 50,
    };
}
